export default __webpack_public_path__ + "static/media/payNowIcon.86f13e05.svg";